export enum PayType {
  Tron = 0,
  Ethereum = 1,
  Alipay = 2,
  Dogecoin = 3,
  Card = 4,
  Balance = 5,
  Blockchain = 6,
}

export enum PayCode {
  Success = 0,
  Waiting = 2222,
  Invalid = 9999,
}

export interface PaymentResult<T = unknown> {
  code: number;
  success: boolean;
  message?: string;
  data?: T;
}

export interface PaymentError extends Error {
  info?: { code?: number; message?: string };
}

// 只传入请求配置，不发送到接口参数或请求体。
export interface PaymentRequestContext {
  isPaymentRequestCurrent: () => boolean;
  // 仅支付轮询接管业务结果提示，网络及登录错误仍由全局处理。
  handlePaymentErrorLocally?: boolean;
}

export interface PaymentInfo {
  amount?: number | string;
  address?: string;
  // 实际剩余秒数，所有支付倒计时统一使用此字段。
  remainingTime?: number | null;
  validTime?: number | string | null;
}

export interface PaymentBindings {
  appId?: number | string;
  sdkInfoId?: number | string;
  userPlanId?: number | string;
}

// 弹窗关闭时订单字段可以为空，只有当前支付会话才启用轮询。
export interface PaymentTransactionParams extends PaymentBindings {
  id?: number | string;
  amount: number | string;
  address: string;
  addressType?: number;
  userId?: number | string;
  pacType?: 0 | 1 | 2;
  reNew: boolean;
  isPlanStep?: boolean;
  number?: number;
  packageType?: number;
  value?: number;
}

export interface OrderPaymentParams extends PaymentBindings {
  addressType: PayType;
  totalAmount: string;
  userId?: number | string;
  pacType: 0 | 1 | 2;
  reNew: boolean;
  id?: number | string;
  planId?: number | string;
  isPlanStep?: boolean;
  number?: number;
  packageType?: number;
  value?: number;
  description?: string;
  orderName?: string;
  currentUrl?: string;
}
